import AuthenticationContext from "config/context/authenticationContext";
import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useState } from "react";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useSetHotKey = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { updateAuthKey } = useContext(AuthenticationContext);

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const setHotKey = async ({ permission, pk }) => {

        setLoading(true);

        try {
            const res = await fetch(`${URL}/api/account/set_auth_key`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                credentials: 'include',
                body: JSON.stringify({
                    account_name: selectedAccount,
                    permission_name: permission,
                    permission_private_key: pk,
                    server_url: selectedServer
                }),
            });

            const data = await res.json();
            setResponse(data);
            updateAuthKey(permission, true, data?.expiration);

            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    const resetServerStatus = useCallback(() => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }, [])

    return {
        response,
        loading,
        error,
        setHotKey,
        resetServerStatus
    };
};